import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import { STCSchedulingConfigModel } from 'data-ng-custom-text';
import * as _4 from 'lodash4';
import {
  IUpcomingAppointmentsDS,
  UpcomingAppointmentsDatasource
} from '../datasources/upcoming_appointments_datasource';
import { AppointmentsCommandServant } from '../servants/appointments_command_servant';
import { IActiveVisit } from '../types/appointment_interfaces';

angular
  .module('capability-ng-appointments')
  .factory(
    'checkoutAppointmentCommand',
    (
      defineCommand: IDefineCommand,
      log: any,
      ngAppointmentsCommandServant: AppointmentsCommandServant,
      QueryMediator: IQueryMediator,
      ngUpcomingAppointmentsDatasource: UpcomingAppointmentsDatasource,
      clearAppointmentsCacheOnServerCommand: ICommand,
      authToken: any,
      ngStcSchedulingConfigModel: STCSchedulingConfigModel
    ): ICommand => {
      return defineCommand(
        'checkoutAppointmentCommand',
        (deferred: ng.IDeferred<IQuery[]>, visit_id: number, attendance_id: number): void => {
          const data = {
            visit_id
          };
          if (ngStcSchedulingConfigModel.read().v3_student_scheduler_flag) {
            authToken
              .campusTokenRequest({
                method: 'POST',
                url: '/api/v3/student_resources/checkouts',
                data
              })
              .then((response: any) => {
                clearAppointmentsCacheOnServerCommand();
                deferred.resolve(response);
              })
              .catch((error: Error) => {
                log.error('unable to checkout appointment');
                deferred.reject(error);
              });
          } else {
            ngAppointmentsCommandServant
              .request({
                url: 'checkouts',
                method: 'POST',
                data
              })
              .then((response: any) => {
                clearAppointmentsCacheOnServerCommand();
                deferred.resolve(response);
              })
              .catch((error: any) => {
                log.error('unable to checkout appointment');
                deferred.reject(error);
              });
          }
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/commands/appointments_checkout_command.ts